/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormFieldComponent } from '@angular-kit/view';

@Component({
  selector: 'kit-bs-form-field',
  templateUrl: './bs-form-field.component.html',
  styleUrls: ['./bs-form-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BsFormFieldComponent extends FormFieldComponent {
  // TODO: add explicit constructor


  get hostClass(): string {
    return 'kit-form-field form-group row';
  }

}
